module.exports = __webpack_public_path__ + "img/equate_non_drowsy_daytime_and_nighttime_multi_symptom_cold_caplets.ed33c2cc.png";